<template>
    <div class="app-content content px-3 py-3">
        <backToDashboard></backToDashboard>
        <div class="content-wrapper">
            <div class="content-header row">
                <div class="content-header-left col-md-6 col-12 mb-2">
                    <h2 class="content-header-title mt-4 mb-0 d-inline-block">{{ $t('previous_notes') }}</h2>
                </div>
            </div>
            <div class="content-body">
                <!-- Basic example section start -->
                <div class="card-group">
                    <note v-for="(item, index) in notes" :note="item" :key="index + 'note'"></note>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import backToDashboard from '../components/layout/backToDashboard.vue'
import note from '../components/layout/note.vue'

export default {
  components: {
    backToDashboard: backToDashboard,
    note: note
  },
  computed: {
    notes () {
      return this.$store.getters.getNotes.data
    }
  }
}
</script>

<style scoped>
body {
    overflow: hidden;
}
.content-body{
    overflow-y: auto
}
</style>
